export const QUERY_KEYS = {
  FEATURES: 'App/features',
  ALL_FEATURES: 'App/all_features',
  MULTI_SITE: 'App/multi_site',
};
